<template>
    <PropertiesEditorBase
        class="widget-properties-editor-input-number"
        name="input number"
        :fields="['label', 'placeholder']"
        v-model:widget="widgetRef"
    >
    </PropertiesEditorBase>
</template>

<script setup>
import { useVModel } from '@vueuse/core';

import PropertiesEditorBase from './PropertiesEditorBase.vue';

const props = defineProps({
    widget: {
        type: Object,
        required: true,
    },
});
const emit = defineEmits(['update:widget']);

const widgetRef = useVModel(props, 'widget', emit);

console.log('PROPERTIES EDITOR INPUT NUMBER: ', widgetRef.value);
</script>
